__webpack_require__.p = "https://bmidxbfranceplprod.netlify.app/";